var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 36,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.368 36V9.6C4.368 6.688 5.232 4.368 6.96 2.64C8.688 0.879997 11.152 -2.86102e-06 14.352 -2.86102e-06C15.44 -2.86102e-06 16.48 0.111998 17.472 0.335999C18.496 0.559998 19.36 0.911998 20.064 1.392L18.096 6.816C17.68 6.528 17.216 6.304 16.704 6.144C16.192 5.984 15.648 5.904 15.072 5.904C13.984 5.904 13.136 6.224 12.528 6.864C11.952 7.472 11.664 8.4 11.664 9.648V12.048L11.856 15.264V36H4.368ZM0.384 16.512V10.752H18.288V16.512H0.384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f74f844dfdac839262db5b34ba9d7f18.svg";
export { ForwardRef as ReactComponent };